import React, { useEffect, useState, useRef } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space, notification } from "antd";
import Pagination from "@mui/material/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faEdit,
  faThumbsDown,
  faThumbsUp,
  faEllipsis,
  faCloudDownload,
  faCheckCircle,
  faExclamationCircle,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import TobNavBar from "../../DashBaord/Top_navbar";
import ShowData from "../../../components/ShowData";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  list,
  changeStatus,
} from "../../../controllers/V1/cms/campaignController";
import { getPage } from "../../../controllers/common";
import ExportPopup from "./Export";
// import { ASSETS_BASE_URL } from "../../../config/constants";
import { a11yProps, VendorList } from "../../../components/common";
import DrawDateTime from "./drawDateTime";
import { usePermissions } from "../../../controllers/PermissionContext";
const CampaignList = () => {
  const PERMISSION = usePermissions("campaign");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);
  const [drawItem, setDrawItem] = useState("");
  const [isDrawOpen, setIsDrawOpen] = useState(false);
  const handleDrawDateTime = () => setIsDrawOpen(!isDrawOpen);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);

  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === "title"
            ? { title: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "category"
            ? { category: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "sub_category"
            ? { sub_category: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "countdown_status"
            ? { countdown_status: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "store_name"
            ? { store_name: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "rumble_add_on_amount"
            ? { rumble_add_on_amount: parseInt(filter?.search) }
            : null),
          ...(filter?.filter_by === "chance_add_on_amount"
            ? { chance_add_on_amount: parseInt(filter?.search) }
            : null),
          ...(filter?.filter_by === "straight_add_on_amount"
            ? { straight_add_on_amount: parseInt(filter?.search) }
            : null),
          ...(filter?.filter_by === "lotto_type"
            ? { lotto_type: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "enable_number_range_prefix"
            ? {
                enable_number_range_prefix: {
                  $regex: filter?.search,
                  $options: "i",
                },
              }
            : null),
          ...(filter?.filter_by === "ticket_number_repeat"
            ? { ticket_number_repeat: parseInt(filter?.search) }
            : null),
          ...(filter?.filter_by === "lotto_range_prefix"
            ? { lotto_range_prefix: parseInt(filter?.search) }
            : null),
          ...(filter?.from
            ? {
                createdAt: {
                  $gte: new Date(`${filter.from} 0:01:00`),
                  $lte: new Date(`${filter.from} 23:59:00`),
                },
              }
            : null),
          ...(showRequest ? { status: showRequest } : null)
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT));
        } else {
          setListData([]);
          setTotalPages(getPage(1));
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter("");
      inputRef1.current.value = "";
      inputRef2.current.value = "";
      inputRef3.current.value = "";
      inputRef4.current.value = "";
    } catch (error) {}
  };

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre) => ({
        ...pre,
        filter_by: form.get("filter_by") || "",
        search: form.get("search") || "",
        to: form.get("to_date") || "",
        from: form.get("from_date") || "",
      }));
      // console.log('filter',filter);
      // alert('submit');
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {}
  };

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef?.current?.scrollIntoView({
      behavior: "smooth",
    });
    document.title = "Crown-King || Campaign's list";
  }, [currentPage, showRequest, filter, LIMIT]);

  const handleEdit = (items) => {
    navigate("/campaign/addeditdata", { state: items });
  };

  const handleChangeStatus = async (id = "", status = "") => {
    try {
      if (!id) {
        notification.open({
          message: "Oops!",
          description: `Id not found.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon
              icon={faExclamationCircle}
              style={{ color: "red" }}
            />
          ),
          duration: 2,
        });
      } else if (!status) {
        notification.open({
          message: "Oops!",
          description: `Status not pass.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon
              icon={faExclamationCircle}
              style={{ color: "red" }}
            />
          ),
          duration: 2,
        });
      } else {
        const option = { id: id, status: status };
        const res = await changeStatus(option);
        if (res.status === true) {
          getList();
          notification.open({
            message: "Success",
            description: `User updated successfully..`,
            placement: "topRight",
            icon: (
              <FontAwesomeIcon
                icon={faCheckCircle}
                style={{ color: "green" }}
              />
            ),
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: (
              <FontAwesomeIcon
                icon={faExclamationCircle}
                style={{ color: "red" }}
              />
            ),
            duration: 2,
          });
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Campaign's list"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("")}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div>
                    <ShowData setLimit={setLimit} limit={LIMIT}/>
                  </div>
                  <div
                    className="inventory_filter_div"
                    onClick={handleFiterDrawer}
                  >
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>
                  {(PERMISSION?.fullAccess === "Y" ||
                    PERMISSION?.export === "Y") && (
                    <div
                      className="inventory_filter_div"
                      onClick={handleExportDrawer}
                    >
                      <FontAwesomeIcon icon={faCloudDownload} />
                      <Link
                        to={false}
                        className="filter_btn_invontry_rating_review"
                      >
                        {" "}
                        Export{" "}
                      </Link>
                    </div>
                  )}
                  {(PERMISSION?.fullAccess === "Y" ||
                    PERMISSION?.setting === "Y") && (
                    <div
                      onClick={() =>
                        navigate("/campaign/setting/addeditdata", {
                          state: "Global",
                        })
                      }
                    >
                      <button
                        type="button"
                        class="btn btn-primary"
                        style={{
                          backgroundColor: "#ae1151",
                          border: "1px solid #ae1151",
                        }}
                      >
                        <span className="request_new_categories ">Setting</span>
                      </button>
                    </div>
                  )}
                  {(PERMISSION?.fullAccess === "Y" ||
                    PERMISSION?.addEdit === "Y") && (
                    <div onClick={() => navigate("/campaign/addeditdata")}>
                      <button type="button" class="btn btn-dark mx-2">
                        <span className="request_new_categories">Add New</span>
                      </button>
                    </div>
                  )}
                  <div className="inventory_filter_div"> 
                    <Link to={false} onClick={()=>getList()}><FontAwesomeIcon icon={faRefresh}/></Link>
                  </div>
                </div>
              </div>
            </Box>
            <VendorList>
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Title</th>
                              <th>Category</th>
                              <th>Sub Category</th>
                              <th>Points</th>
                              <th>Draw Date & Time</th>
                              <th>Seq. Order</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.title}</td>
                                  <td>{item.category}</td>
                                  <td>{item.sub_category}</td>
                                  <td>
                                    Straight:{item.straight_add_on_amount}{" "}
                                    <br /> Rumble:{item.rumble_add_on_amount}{" "}
                                    <br /> Chance:{item.chance_add_on_amount}{" "}
                                  </td>
                                  <td>
                                    {moment(item.draw_date).format(
                                      "DD-MM-YYYY"
                                    )}{" "}
                                    <br />
                                    {item.draw_time}
                                  </td>
                                  <td>{item?.seq_order || '-'}</td>
                                  <td>{item.status}</td>
                                  <td>
                                    <Dropdown
                                      placement="bottomLeft"
                                      arrow
                                      overlay={
                                        <Menu>
                                          {(PERMISSION?.fullAccess === "Y" || PERMISSION?.addEdit === "Y") && (
                                            <Menu.Item key={`1`} onClick={() => { handleEdit(item); }} >
                                              <FontAwesomeIcon icon={faEdit} />{" "}
                                              <span className="show_span">
                                                Edit
                                              </span>
                                            </Menu.Item>
                                          )}
                                          {(PERMISSION?.fullAccess === "Y" || PERMISSION?.prize === "Y") && (
                                            <Menu.Item
                                              key={`5`}
                                              onClick={() => {
                                                navigate(
                                                  "/campaign/prize/addeditdata",
                                                  { state: item }
                                                );
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faEdit} />{" "}
                                              <span className="show_span">
                                                Prize
                                              </span>
                                            </Menu.Item>
                                          )}
                                          {(PERMISSION?.fullAccess === "Y" || PERMISSION?.setting === "Y") && (
                                            <Menu.Item
                                              key={`6`}
                                              onClick={() => {
                                                navigate(
                                                  "/campaign/setting/addeditdata",
                                                  { state: item }
                                                );
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faEdit} />{" "}
                                              <span className="show_span">
                                                Setting
                                              </span>
                                            </Menu.Item>
                                          )}

                                          {(PERMISSION?.fullAccess === "Y" || PERMISSION?.drawDate === "Y") && (
                                            <Menu.Item
                                              key={`4`}
                                              onClick={() => {
                                                handleDrawDateTime();
                                                setDrawItem(item);
                                              }}
                                            >
                                              <FontAwesomeIcon icon={faEdit} />{" "}
                                              <span className="show_span">
                                                Draw Date/Time
                                              </span>
                                            </Menu.Item>
                                          )}

                                          {((item.status === "I" || item.status === "B") && (PERMISSION?.fullAccess === "Y" || PERMISSION?.changeStatus === "Y")) && (
                                            <Menu.Item
                                              key={`2`}
                                              onClick={() =>
                                                handleChangeStatus(
                                                  item._id,
                                                  "A"
                                                )
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faThumbsUp}
                                              />{" "}
                                              <span className="show_span">
                                                Active
                                              </span>
                                            </Menu.Item>
                                          )}
                                          {(item.status === "A" && (PERMISSION?.fullAccess === "Y" || PERMISSION?.changeStatus === "Y")) && (
                                            <Menu.Item
                                              key={`3`}
                                              onClick={() =>
                                                handleChangeStatus(
                                                  item._id,
                                                  "I"
                                                )
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faThumbsDown}
                                              />{" "}
                                              <span className="show_span">
                                                Inactive
                                              </span>
                                            </Menu.Item>
                                          )}
                                        </Menu>
                                      }
                                    >
                                      <FontAwesomeIcon icon={faEllipsis} />
                                    </Dropdown>
                                  </td>
                                </tr>
                              ))
                            ) : isLoading ? (
                              <SkeltonList row={5} col={9} />
                            ) : (
                              <tr>
                                <td colSpan="9" className="img-center">
                                  No data found!
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
      <DrawDateTime
        drawDateTimeOpen={isDrawOpen}
        toggleDrawPopUp={handleDrawDateTime}
        drawItem={drawItem}
        getList={getList}
      />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button
              type="primary"
              onClick={handleFilterReset}
              style={{ backgroundColor: "red", color: "white" }}
            >
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id="filter_form" onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  Search Field :
                </label>
                <select
                  name="filter_by"
                  className="form-control store_input_field"
                  id="filter_by"
                  ref={inputRef1}
                >
                  <option value="">Select search field</option>
                  <option
                    value="title"
                    selected={filter?.filter_by === "title" ? true : false}
                  >
                    Title
                  </option>
                  <option
                    value="category"
                    selected={filter?.filter_by === "category" ? true : false}
                  >
                    Category
                  </option>
                  <option
                    value="sub_category"
                    selected={
                      filter?.filter_by === "sub_category" ? true : false
                    }
                  >
                    Sub Category
                  </option>
                  <option
                    value="straight_add_on_amount"
                    selected={
                      filter?.filter_by === "straight_add_on_amount"
                        ? true
                        : false
                    }
                  >
                    Straight Points
                  </option>
                  <option
                    value="rumble_add_on_amount"
                    selected={
                      filter?.filter_by === "rumble_add_on_amount"
                        ? true
                        : false
                    }
                  >
                    Rumble Points
                  </option>
                  <option
                    value="chance_add_on_amount"
                    selected={
                      filter?.filter_by === "chance_add_on_amount"
                        ? true
                        : false
                    }
                  >
                    Chance Points
                  </option>
                  <option
                    value="status"
                    selected={filter?.filter_by === "status" ? true : false}
                  >
                    Status
                  </option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"
                  ref={inputRef2}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="from_date"
                  className="form-control store_input_field"
                  id="from_date"
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="to_date"
                  className="form-control store_input_field"
                  id="to_date"
                  ref={inputRef4}
                />
              </div>
              <br />
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default CampaignList;
